module.exports = __webpack_public_path__ + "img/icon-arrow-down-dark.b85e76f6.svg";